export const NO_ACCESS_TOKEN_FOUND_IN_AUTH_RESPONSE =
  "No access token found in auth response";
